import { apiEmpleo } from "../../util/ApiEmpleo";

export interface IApiGetServiceHolders {
  itemsPerPage?: number;
  searchFor?: string;
  page?: number;
}

const apiGetServiceHolders = async (params: IApiGetServiceHolders) => {
  let res = await apiEmpleo.get(`service_holders`, { params });

  return res;
};

export { apiGetServiceHolders };
